/**
 * API 客户端
 */

const API_BASE = import.meta.env.PROD ? '/api' : '/api';

export interface Status {
  producer: TaskStatus;
  audio: TaskStatus;
  topics: Topic[];
}

export interface TaskStatus {
  status: 'idle' | 'running' | 'completed' | 'failed';
  total: number;
  completed: number;
  progress: number;
  lastUpdate: string | null;
  inProgress?: string;
  failed?: number[];
}

export interface Topic {
  id: number;
  title: string;
  summary: string;
}

export interface LogEntry {
  type: 'info' | 'error' | 'warning';
  message: string;
  timestamp: string;
  source?: string;
}

/**
 * 获取状态
 */
export async function getStatus(): Promise<Status> {
  const res = await fetch(`${API_BASE}/status`);
  if (!res.ok) throw new Error('Failed to fetch status');
  return res.json();
}

/**
 * 启动脚本生成
 */
export async function startProducer(): Promise<{ success: boolean; message: string; pid: number }> {
  const res = await fetch(`${API_BASE}/start/producer`, { method: 'POST' });
  if (!res.ok) throw new Error('Failed to start producer');
  return res.json();
}

/**
 * 启动音频生成
 */
export async function startAudio(): Promise<{ success: boolean; message: string; pid: number }> {
  const res = await fetch(`${API_BASE}/start/audio`, { method: 'POST' });
  if (!res.ok) throw new Error('Failed to start audio');
  return res.json();
}

/**
 * 停止所有任务
 */
export async function stopAll(): Promise<{ success: boolean; message: string }> {
  const res = await fetch(`${API_BASE}/stop`, { method: 'POST' });
  if (!res.ok) throw new Error('Failed to stop tasks');
  return res.json();
}

/**
 * 获取主题列表
 */
export async function getTopics(): Promise<Topic[]> {
  const res = await fetch(`${API_BASE}/topics`);
  if (!res.ok) throw new Error('Failed to fetch topics');
  return res.json();
}
